import { Component, OnInit, OnDestroy } from '@angular/core';

// servicios
import { CambiarPasswordService } from 'src/app/services/cambiar-password.service';
import { UsuarioService } from 'src/app/services/datos/usuario.service';

// interfaces 
import { IUsuario } from 'src/app/interfaces/usuario';
import { environment } from 'src/environments/environment';
import { CronTotalesMenuService } from 'src/app/services/cron-totales-menu.service';
import { InactividadService } from 'src/app/services/inactividad.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {

  entorno: string = environment.entorno;

  public tiempoRestante: number = 0;
  private timerCountdown: any;

  constructor(
    public usuarioSrv: UsuarioService,
    private cambiarPswSrv: CambiarPasswordService,
    public cronTotalesSrv: CronTotalesMenuService,
    private inactividadSrv: InactividadService
  ) { }

  ngOnInit(): void {
    // Actualizar cada segundo
    this.timerCountdown = setInterval(() => {
      this.tiempoRestante = this.inactividadSrv.getRemainingTime();
    }, 1000);
  }

  ngOnDestroy(): void {
    if (this.timerCountdown) {
      clearInterval(this.timerCountdown);
    }
  }

  logOut() {
    this.usuarioSrv.logOut();
  }

  getUserFoto() {
    return (this.usuarioSrv.getUserFoto());
  }

  async openChangePasswordModal(user: IUsuario): Promise<void> {
    const success = await this.cambiarPswSrv.showChangePasswordModal(user); // ID del usuario

    if (success) {
      console.log('Contraseña cambiada exitosamente');
    }
  }

}
